import styled from 'styled-components'

import { Box } from 'app/components/design-system-components'
import { Text } from 'app/components/design-system-components/typography'
import theme from 'app/match/applicationReportPDF/assets/theme'

export const NSW_PET_HEADING = 'NSW Pet Information'
const UnstyledLi = styled.li`
  display: list-item !important;
`

const UnstyledUl = styled.ul`
  padding-inline-start: 20px !important;
  padding-left: 0;
`

export const NSWPetNonExpandContent = (
  <Box>
    Snug enables you to submit details for Part A and apply to keep a pet in a
    rental property. You can download the PDF here or review further information
    about consent process, exceptions, description of animals, limited reasons
    for refusal.
  </Box>
)

export const NSWPetContent = (
  <>
    <Text
      fontSize={theme.fontSizes.pRegular14}
      color="deepBlue"
      fontWeight="bold"
      mb={2}
      mt={3}
    >
      What’s this form for?
    </Text>
    <UnstyledUl>
      <UnstyledLi>
        Tenants must use part A of this form to ask for approval to keep pet/s
        in a rental property.
      </UnstyledLi>
      <UnstyledLi>
        The landlord must fill out part B of this form to respond to the
        tenant’s request.
      </UnstyledLi>
    </UnstyledUl>

    <Text
      fontSize={theme.fontSizes.pRegular14}
      color="deepBlue"
      fontWeight="bold"
      mb={2}
      mt={6}
    >
      How to use this form
    </Text>
    <UnstyledUl>
      <UnstyledLi>
        Tenants must provide information about the pet/s they want to keep.
      </UnstyledLi>
      <UnstyledLi>
        The landlord must respond within 21 days after the tenant gives them
        this form. If they don’t respond, the pet is approved.
      </UnstyledLi>
      <UnstyledLi>
        If the landlord approves the pet, they can ask the tenant to agree to
        reasonable conditions for the pet (section B2).
      </UnstyledLi>
      <UnstyledLi>
        If the landlord refuses the pet, they must explain their refusal. They
        can only refuse for certain reasons (section B3).
      </UnstyledLi>
      <UnstyledLi>
        You can complete this form using a PDF reader and add your electronic
        signature, or you can print it out.
      </UnstyledLi>
      <UnstyledLi>
        If there is not enough space anywhere on this form, you can add
        attachments.
      </UnstyledLi>
    </UnstyledUl>

    <Text
      fontSize={theme.fontSizes.pRegular14}
      color="deepBlue"
      fontWeight="bold"
      mb={2}
      mt={6}
    >
      Exceptions
    </Text>
    <UnstyledUl>
      <UnstyledLi>
        Tenants do not need to submit this form or ask for landlord approval for
        an assistance animal. Tenants with an assistance animal should notify
        the landlord of the animal.
      </UnstyledLi>
      <UnstyledLi>
        Tenants who have already received consent for their animal do not need
        to submit this form.
      </UnstyledLi>
      <UnstyledLi>
        Tenants who live in purpose-built student accommodation do not need to
        use this form.Terms used in this form.
      </UnstyledLi>
      <UnstyledLi>The Act means the Residential Tenancies Act 2010.</UnstyledLi>
      <UnstyledLi>
        Tenant means a tenant that has entered into a residential tenancy
        agreement.
      </UnstyledLi>
      <UnstyledLi>
        Co-tenants means all tenants listed on the residential tenancy
        agreement.
      </UnstyledLi>
      <UnstyledLi>
        Landlord means a person who grants the right to occupy residential
        premises.
      </UnstyledLi>
      <UnstyledLi>
        Rental property means a rented residential premises under the Act.
      </UnstyledLi>
      <UnstyledLi>
        Pet means an animal. It does not include an assistance animal. The type
        of animal that can be a pet is not limited by the Act.
      </UnstyledLi>
      <UnstyledLi>
        Assistance animal means an animal trained or accredited to assist a
        person with a disability, as in the Disability Discrimination Act 1992
        (Cth).
      </UnstyledLi>
    </UnstyledUl>

    <Text
      fontSize={theme.fontSizes.pRegular14}
      color="deepBlue"
      fontWeight="bold"
      mb={2}
      mt={6}
    >
      Description of animal/s – if known:
    </Text>
    <UnstyledUl>
      <UnstyledLi>
        (Give more details on the type of animal/s and describe any identifying
        features. For example, fur colour, markings or size, if known. Clearly
        label each animal). You may also want to give information explaining why
        you think your pet/s should be approved. If helpful, you can respond to
        the questions below:
      </UnstyledLi>
      <UnstyledLi>
        How is the rental property suitable for the pet/s? (For example, size of
        the property, outdoor areas, gates/fences)
      </UnstyledLi>
      <UnstyledLi>
        Are the pet/s permitted under local council laws? (For example, consider
        any local council restrictions limiting the number of animals)
      </UnstyledLi>
      <UnstyledLi>
        Do you have permits or licences for the type of animal, if needed? (For
        example, for native reptiles)
      </UnstyledLi>
      <UnstyledLi>
        Will the pet/s be kept inside, outside or in an enclosure? (For example,
        hutch, cage or fish tank)
      </UnstyledLi>
      <UnstyledLi>
        Any information regarding the pet/s welfare? (For example, enrichment
        activities, daily exercise and care routines)
      </UnstyledLi>
      <UnstyledLi>
        If you already have approved pets, how will they live together?(Note: If
        applying for multiple pets, be clear about which animal/s you are
        referring to)
      </UnstyledLi>
    </UnstyledUl>
    <Text fontSize={theme.fontSizes.pRegular14} color="deepBlue">
      Note: If you do not yet have your pet, complete as much information as
      possible about the kind of animal/s you intend to keep. The following
      information is needed to help your landlord make an informed decision.
    </Text>
    <Text fontSize={theme.fontSizes.pRegular14} color="deepBlue">
      The request to keep a pet must be made jointly by all co-tenants.
    </Text>

    <Text
      fontSize={theme.fontSizes.pRegular14}
      color="deepBlue"
      fontWeight="bold"
      mb={2}
      mt={6}
    >
      Reason/s for refusal:
    </Text>
    <UnstyledUl>
      <UnstyledLi>
        Unreasonable number of animals: Keeping the pet would lead to an
        unreasonable number of animals at the property.
      </UnstyledLi>
      <UnstyledLi>
        Fencing: The fencing at the property is not appropriate for the pet.
      </UnstyledLi>
      <UnstyledLi>
        Open space: The property is not suitable because there is not enough
        open space.
      </UnstyledLi>
      <UnstyledLi>
        Welfare: The pet could not be kept at the property humanely.
      </UnstyledLi>
      <UnstyledLi>
        Damage: It is highly probable the pet will cause damage exceeding the
        bond.
      </UnstyledLi>
      <UnstyledLi>
        Other laws: It is against another Act or law (such as local council
        orders), or strata/community by-laws or rules, to keep the pet in the
        rental property.
      </UnstyledLi>
      <UnstyledLi>The landlord lives at the rental property.</UnstyledLi>
      <UnstyledLi>
        The tenant did not agree to a reasonable condition for keeping the pet.
      </UnstyledLi>
    </UnstyledUl>

    <Text
      fontSize={theme.fontSizes.pRegular14}
      color="deepBlue"
      fontWeight="bold"
      mb={2}
      mt={6}
    >
      Further information and guidance
    </Text>
    <Text fontSize={theme.fontSizes.pRegular14} color="deepBlue">
      For more information about landlord and tenant rights and
      responsibilities, please visit{' '}
      <a
        href="https://www.nsw.gov.au/housing-and-construction/renting-a-place-to-live"
        target="_blank"
        rel="noreferrer"
      >
        nsw.gov.au/renting
      </a>
      . If you are a tenant and think the landlord’s reason for refusing a pet
      is not applicable, or a condition they have set is unreasonable, you can
      contact NSW Fair Trading to discuss the issue. Tenants can also apply to
      the NSW Civil and Administrative Tribunal for a decision. To learn more
      about dispute options visit
      nsw.gov.au/housing-andconstruction/renting-a-place-to-live/resolving-residential-tenancy-disputes.
      For any other complaints or enquiries visit Housing and property
      complaints and enquiries | NSW Government or call Fair Trading on 13 32
      20. This form is made under sections 73C and 73D of the Residential
      Tenancies Act 2010 (the Act). For other relevant legislation see Part 3,
      Division 8 of the Act and clause 22A of the Residential Tenancies
      Regulation 2019.
    </Text>
  </>
)
